module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA3.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA3"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.26.0.0.box.193.577.851.321.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA3.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_heading",
    attrs: {
      "id": "para.26.0.0.box.193.577.306.33.q.80"
    }
  }, [_vm._v("CHAPTER 1")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA3.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_heading",
    attrs: {
      "id": "para.26.0.1.box.382.787.662.111.q.90"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("The ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Old ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Country ")])])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.26.1.0.box.192.1106.1356.1358.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA3.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "2em"
    },
    attrs: {
      "id": "para.26.1.0.box.192.1106.1350.264.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA3.w.2.0.0"
    }
  }), _vm._v("Italian ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Immigrants ")]), _vm._v("had a special legacy to the New World. For it was discovered by the Italian Christopher Columbus and was named for the Italian Amerigo Vespucci. These two facts were undoubtedly known to Lorenzo Casso and his brother, Pietro, and influenced their coming to the United States.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA3.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.26.1.1.box.194.1383.1349.260.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA3.w.2.1.0"
    }
  }), _vm._v("It is difficult for anyone to separate himself from family, home, and country under any circumstances, so there were surely other factors that prompted Lorenzo and his brother to seek a future far from their homeland. If we are to learn anything about them, we must reflect upon the prevailing politics and economy of their time.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA3.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.26.1.2.box.194.1656.1351.587.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA3.w.2.2.0"
    }
  }), _vm._v("Europe has always been in political and economic upheaval which has kept its citizens and their governments in a constant state of fomentation. Italy, especially, being at the crossroads of western civilization, was for centuries a pawn to be fought over or bargained for within the practical scheme of politics. Even such a noble venture as the Crusades took its invading armies trespassing across Italy, living off the produce of its lands and intimidating its citizens. Of all the countries in Europe, Italy—the cradle of civilization—was in a geographical position to be extremely valuable to the contesting forces; its occupation meant control of the Mediterranean Sea and offered a natural stepping stone to Africa and the Middle East.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA3.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.26.1.3.box.197.2256.1351.208.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA3.w.2.3.0"
    }
  }), _vm._v("During Lorenzo's boyhood, Italy was unusually beset with events seldom experienced by other countries. While some citizens fought for a complete union of a politically divided Italy, other forces were fighting and scheming to retain the status quo since it served their"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA4.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.27.1.0.box.194.356.1345.320.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA4"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.1.0.0"
    }
  }), _vm._v("\nown particular interests. This meant, of course, that while brothers were fighting brothers, factions of brothers were scheming with foreign nations to keep Italy divided. To further appreciate the complications that prevailed prior to Lorenzo's decision to seek his future in the New World, one must look into the Napoleonic Wars and the subsequent events which led to civil war forty years later.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA4.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA4"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.27.1.0.box.194.356.1349.1897.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA4.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.27.1.1.box.196.686.1347.1239.q.60"
    }
  }, [_vm._v("Napoleon, though born a French citizen, considered himself Italian since all his ancestors came from the Italian mainland. He wrote in the margin of Machiavelli's book, \"I too am an Italian.\" Proud of his descent and enthralled with the glories of the Roman Empire, yet conscious of the need of a buffer state against his archenemy, Austria, he was the first to encourage a nationalistic spirit in Italy. When he came to power he did away with the eleven states of the Italian peninsula, and except for retaining some small enclaves which he gave to his family or to favored officials, he divided Italy into three parts. The Kingdom of Piedmont and Savoy, which abutted France and also included the island of Sardinia, the Grand Duchy of Tuscany, the Duchy of Parma, the old Republic of Genoa, the Dalmatian provinces of the Republic of Venice, and all the papal states west of the Appenines were incorporated into France. Continental Venice, Lombardy, the Romagna, and the Marches and the Duchy of Modena were forged into the Kingdom of Italy. Napoleon then made his stepson Eugene de Beauharnais the viceroy of the newly formed kingdom. The fact that even with this partial union only one portion of it was known as Italy is of particular significance to us as we shall see later. The South of Italy, excepting Sicily, which remained under Bourbon rule, was given to Napoleon's brother Joseph as king of Naples, but later when Joseph went to Spain, Joachim Murat, husband of Napoleon's youngest sister, Caroline, became its king."), _c('sup', [_vm._v("1")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA4.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.27.1.2.box.197.1937.1344.316.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA4.w.1.2.0"
    }
  }), _vm._v("After Napoleon's last abdication in 1815, the Congress of Vienna set about breaking Italy into small sections again and returning territories, wherever possible, to their former rulers. Metternich, Austria's prime minister, contemptuously referred to Italy as a mere geographical expression and certainly not a nation. The Bourbons were restored to the throne of Naples including Sicily. The Pope was given back"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA5.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.28.1.0.box.195.347.1346.152.q.60"
    }
  }, [_vm._v("\nthe Vatican states, and the House of Savoy regained the Piedmont crown and Sardinia which included Savoy, Nice, and the former Republic of Genoa.")])])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_footnote",
    attrs: {
      "id": "block.27.2.0.box.198.2290.1345.185.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA4.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_footnote",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.27.2.0.box.198.2290.1345.185.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA4.w.2.0.0"
    }
  }), _vm._v("1 In March 1970 my wife, who is also of Italian ancestry, and I had dinner with the heirs presumptive to the Kingdom of Naples, Prince Napoleon Murat and his wife. The intervening years seem to disappear as two persons, descendants of Italians who sought their future in the New World, sat conversing and discussing the politics of the times with old-world royalty.")]), _c('a', {
    attrs: {
      "id": "GBS.PA5"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.1.0.0"
    }
  })])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA5.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA5.w.1.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA5.w.1.2.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA5"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.28.1.0.box.192.347.1349.2122.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA5.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.28.1.1.box.194.512.1345.145.q.50"
    }
  }, [_vm._v("Austria, by all means, wanted Lombardy and Venice provinces, the main components of the old Kingdom of Italy; it was also Lorenzo's homeland.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA5.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.28.1.2.box.193.679.1347.317.q.70"
    }
  }, [_vm._v("All these political manipulations were designed to effect the former status quo which favored those countries bordering Italy. Again Italy was divided; Lorenzo's image of his mother country was not one of a complete political and geographic unit as it is known today. He remembered the land of his birth as being composed of all these principalities and of himself as being from one particular principality.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA5.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.28.1.3.box.192.1008.1348.426.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA5.w.1.3.0"
    }
  }), _vm._v("Austria, in possession of Lombardy and Venice, again became a dominant power in Italy. An Austrian archduke received Tuscany while Marie Louise, daughter of the Austrian Emperor and also Napoleon's second wife, who ingloriously deserted his cause, received Parma. In all those parts of Italy as well as those controlled by Austria to which former rulers returned, bitterness and reaction set in. Italy retreated from progress as police spies, press censorship, and clerical privileges became rampant again.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA5.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.28.1.4.box.192.1446.1347.470.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA5.w.1.4.0"
    }
  }), _vm._v("In the Kingdom of Naples and the two Sicilies, a proclamation promising a new constitution was prohibited. All officials in the papal states who had served with the French were summarily dismissed. The French code of law was nullified (the "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Code ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("de ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Napoleon, ")]), _vm._v("the laws under which the state of Louisiana now operates); street lights and vaccinations were abolished. Education was limited to the privileged, taxes were increased, and even public drainage was discontinued. Victor Emmanuel I forbade recognition of any change in government which had been made since 1770.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA5.w.1.5.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.28.1.5.box.192.1938.1347.257.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA5.w.1.5.0"
    }
  }), _vm._v("To fully appreciate the dilemma of the Italian people, one must realize that males were being drafted into various armies to suppress their own kin. Seeds were planted not only for a civil war throughout the Italian peninsula but for the eventual migration of many of its people.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA5.w.1.6.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.28.1.6.box.192.2209.1348.260.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA5.w.1.6.0"
    }
  }), _vm._v("Many Italians were to realize the total futility of the political and economic system of Italy during these dreadful times. From time to time people revolted against their new masters, and in many districts calls for freedom and better government arose from these economic and political pressures. Matters became worse through the years with"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA6.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.29.1.0.box.191.357.1345.97.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA6"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA6.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA6.w.1.0.0"
    }
  }), _vm._v("\nan entrenched aristocracy oblivious and disdainful of the ordinary comforts and rights of citizens.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA6.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA6"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.29.1.0.box.191.357.1345.2117.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA6.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.29.1.1.box.193.467.1342.427.q.60"
    }
  }, [_vm._v("It was into such conditions of economic and social desperation that Lorenzo Casso was born. Things did not change to any appreciable degree from the fall of Napoleon in 1815 until the civil war in Italy which actually did not gain unity of purpose until 1859. The unification of Italy did not become effective until almost a decade later. There were spasmodic outbreaks all over Italy from time to time, however, and these were accompanied by agonizing trials for the populace.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA6.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.29.1.2.box.193.907.1342.412.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA6.w.1.2.0"
    }
  }), _vm._v("John Locke, noted English philosopher, defined education as an effort to implant the ideals of the passing generation into the new. It is certain that Lorenzo learned well from his parents and grandparents of the horrible deprivations and political suppressions they endured through the years. The older generations of the Cassos, father and grandfather, impressed upon the young Lorenzo their frustrated ideals which never had the political climate in which to blossom and bear fruit.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA6.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.29.1.3.box.192.1342.1344.369.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA6.w.1.3.0"
    }
  }), _vm._v("The recollections of the grandfather stretched back to the Napoleonic age. Accounts of the intervening periods of history became Lorenzo's first education; he benefited from listening to the experienced. He was also taught love of family, ideals, and morals for one's advancement and understanding of how the problems of life mold character. Lorenzo learned his lessons well. Not only was his body born in Italy but his mind was as well.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA6.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.29.1.4.box.192.1724.1344.414.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA6.w.1.4.0"
    }
  }), _vm._v("About the time that Lorenzo became a teenager, passions began to erupt. For the first time since the glorious Roman Empire a dream of a united Italy began to take form and found its leader in the remarkable patriot, Giuseppe Garibaldi. This almost uneducated man became the symbol and the power around which the Italians rallied, in a movement that led to the eventual unification of their country. But much suffering, death, and social upheaval were experienced before this dream was realized.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA6.w.1.5.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.29.1.5.box.193.2158.1342.316.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA6.w.1.5.0"
    }
  }), _vm._v("The civil war in Italy was another parade of armed might going up and down the peninsula with the people along the way its victims. This war was actually the result of a series of events beginning with the war between Sardinia and Austria in 1848, when Lorenzo was only thirteen years old. Garibaldi, who had returned to Italy after service in the civil war of Brazil and Uruguay, fought with the Sar"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA7.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.30.1.0.box.191.349.1349.153.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA7"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA7.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA7.w.1.0.0"
    }
  }), _vm._v("dinians. But the Sardinians were defeated, and Lorenzo's Italy was subjected to another foreign landlord, Austria, whom thay all hated. Garibaldi escaped to the United States.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA7.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA7.w.1.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA7.w.1.1.0.2"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA7"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.30.1.0.box.191.349.1350.758.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA7.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.30.1.1.box.192.515.1349.592.q.60"
    }
  }, [_vm._v("When war broke out again between Sardinia and Austria in 1859, Garibaldi returned to Italy and formed a guerrilla army to aid King Victor Emmanuel II. Lorenzo was twenty-four years old; it was during this period that he left Italy and migrated to the United States. Although the exact dates of his departure from Italy and his arrival in the United States are unknown, it is certainly possible that he left Italy at the outbreak of hostilities in 1859 and conceivably sooner. Lorenzo and his brother Pietro (translated Lawrence and Peter) left an area of conflict to seek their fortunes elsewhere. Little did either of them think that not long after their arrival in the United States they would find, ironically, themselves in the midst of another war.")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA8"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA8.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA8.w.0.0.0.1"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-93d28bfe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/content0011.vue
// module id = 63
// module chunks = 0